import React from 'react';

import AvdragsfrihetForm from '../components/avdragsfrihet-form';

const AvdragsfrihetApp = () => <AvdragsfrihetForm />;

export default AvdragsfrihetApp;
